import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

interface DurationOption {
  months: number;
  price: number;
  discount: string;
  renewalPackageID?: number;
}

@Component({
  selector: 'app-month-selection',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './month-selection.component.html',
  styleUrl: './month-selection.component.scss'
})
export class MonthSelectionComponent {
  @Input() selectedDuration: number = 1;
  @Input() currentActiveDuration?: number | null = null;
  @Input() set packageData(data: any) {
    if (data) {
      this.updateDurationOptions(data);
    }
  }
  @Output() durationSelected = new EventEmitter<{months: number, renewalPackageID?: number}>();

  durationOptions: DurationOption[] = [];

  selectDuration(option: DurationOption) {
    this.selectedDuration = option.months;
    this.durationSelected.emit({
      months: option.months,
      renewalPackageID: option.renewalPackageID
    });
  }

  private updateDurationOptions(data: any) {
    // Base option (1 month)
    const baseOption: DurationOption = {
      months: 1,
      price: data.price,
      discount: ''
    };

    // Discounted options
    const discountOptions: DurationOption[] = data.discounts.map((discount: any) => ({
      months: discount.intervalMonths,
      price: discount.price,
      discount: `${discount.discountPercentage}%`,
      renewalPackageID: discount.renewalPackageID
    }));

    // Sort by month (ascending)
    this.durationOptions = [baseOption, ...discountOptions]
      .sort((a, b) => a.months - b.months);
  }
}
